export const PaginatedComments = Symbol('PaginatedComments');
/**
 * 默认每页显示注释的数量
 */
export const DEFAULT_COMMENTS_COUNT_PER_PAGE = 50;
